export function simplifyAnswer(answer){
	let result = answer.replace(/[\W_]+/g, '');
	result = result.toLowerCase();
	return result
}

export function replaceRepeatingLetters(answer) {
 return answer.replace(/(.)\1+/g, "$1")
}
